export enum WorkflowStepFunctionMode {
  Create = 'create',
  Edit = 'edit'
}
